export { trigger, bind, unbind } from './event_DO_NOT_USE.js';
